import { SearchFilterResults as t } from "../SearchFilterResults/SearchFilterResults.js";
function l(e) {
  return e.children == null || e.children == null ? null : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    t,
    {
      onChange: e.onChange,
      order_by: e.order_by,
      order: e.order,
      limit: e.limit,
      resultsCount: e.resultsCount,
      page: e.page,
      orderResultsByChoices: e.orderResultsByChoices,
      showLimit: e.showLimit
    }
  ), e.children, /* @__PURE__ */ React.createElement(
    t,
    {
      onChange: e.onChange,
      order_by: e.order_by,
      order: e.order,
      limit: e.limit,
      resultsCount: e.resultsCount,
      page: e.page,
      orderResultsByChoices: e.orderResultsByChoices,
      showLimit: e.showLimit
    }
  ));
}
export {
  l as TopBottomSearchFilterResults
};
